<template>
  <div class="row">
    <toast ref="toast"></toast>
    <div class="col-md-10 pb-1 pt-1">
        <button class="btn btn-sm btn-outline-dark m-1" style="border-radius:50px;" @click.stop="switchShow">
            <i class="fa" :class="{'fa-chevron-circle-right': !show, 'fa-chevron-circle-left': show}"></i>
            CSVアップロード
        </button>
        <transition>
            <table v-show="show">
                <tr>
                    <td>
                    <button type="button" class="btn btn-info" style="border-radius: 50px;">
                        <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>
                        <a id="download" style="color: white;text-decoration: none;">CSVテンプレート</a>
                    </button>
                    </td>
                    <td>
                    <form  @submit.prevent="confirm" class="form-inline">
                        <input @change="selectedFile" type="file" name="file" id="uploadFile" accept="text/csv">
                        <button v-if="uploadFile" type="submit" class="btn btn-info btn-sm" style="border-radius:50px;">
                            <i class="fa fa-cloud-upload fa-1x" aria-hidden="true"></i>アップロード
                        </button>
                        <button v-if="uploadFile" type="button" class="btn btn-light btn-sm" style="border-radius:50px;" @click="resetUploadFile">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </form>
                    </td>
                </tr>
            </table>
        </transition>
    </div>
  </div>
</template>

<style scoped>
.v-enter-active {
    transition: 1s;
}
.v-leave-active {
    transition: 0.5s;
}

.v-enter, .v-leave-to {
  opacity: 0
}
</style>

<script>
import LeaveRequestAPI from '../../../api/leave-request-api';
import Toast from '../../Toast.vue'

export default {
  name: "yukyu-csv",
  components: {
      Toast
  },
  data() {
    return {
        show: false,
        uploadFile: null,
        loginUser: {
            role: ''
        },
    }
  },
  watch: {
  },
  mounted () {
      this.download()
  },
  methods: {
    switchShow(){
        this.show = !this.show
    },
    // フォーマットダウンロ-ド
    download() {
        var filename = '休暇申請CSVテンプレート'
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        var content = 'メールアドレス,対象日,申請種類（有給=1、特別休暇=2）,全休/半休,申請理由';
        var blob = new Blob([ bom, content ], { "type" : "text/csv" });

        if (window.navigator.msSaveBlob) { 
            window.navigator.msSaveBlob(blob, filename); 

            // msSaveOrOpenBlobの場合はファイルを保存せずに開ける
            window.navigator.msSaveOrOpenBlob(blob, filename); 
        } else {
            document.getElementById("download").href = window.URL.createObjectURL(blob);
            document.getElementById("download").download = filename;
        }
    },
    // ファイル選択
    selectedFile(e) {
        e.preventDefault();
        let files = e.target.files;
        this.uploadFile = files[0];
        this.isInvalidFile()
    },
    // ファイル検証
    isInvalidFile() {
        // サイズチェック
        if (this.uploadFile.size >= 2000000) {
            this.$refs.toast.showToast("※2MB以上のファイルはアップロードできません。", 3000, true)
            this.uploadFile = null
            document.getElementById('uploadFile').value = ''
            return true
        }
        // ファイルタイプチェック
        let splits =this.uploadFile.name.toLowerCase().split(".");
        let extension = splits[splits.length - 1];
        let allowExtension = ["csv"];
        if (allowExtension.indexOf(extension) < 0){
            this.$refs.toast.showToast("※CSV以外のファイルはアップロードできません。", 3000, true)
            this.uploadFile = null
            document.getElementById('uploadFile').value = ''
            return true
        }
        return false
    },
    // 確認
    confirm () {
      if (window.confirm('アップロードしてよろしいですか?')){
        this.upload();
      }
    },
    // アップロード
    upload() {
        // バリデーション
        if(this.uploadFile == null || this.isInvalidFile()){
            return
        }
        this.$root.$refs.loading.$data.show = true
        let formData = new FormData();
        formData.append('file', this.uploadFile);
        LeaveRequestAPI.upload(formData)
            .then(res => {
                this.uploadFile = null
                document.getElementById('uploadFile').value = ''
                this.$root.$refs.loading.$data.show = false
                this.$refs.toast.showToast("ファイルをアップロードしました。", 3000, false)
            })
            .catch(err => {
                console.error(err)
                if(err.response.status == 400 || err.response.status == 403 ){
                    this.$refs.toast.showToast(err.response.data, 3000, true)
                }
                this.$root.$refs.loading.$data.show = false
            })
    },
    resetUploadFile() {
      this.uploadFile = null 
      document.getElementById('uploadFile').value = ''
    }
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/yukyu/YukyuCsv.vue